import { CategoryView } from "@views/Category";
import { NextPage } from "next";

import { Attribute } from "@graphql/gqlTypes/Attribute";
import { FeaturedProducts } from "@utils/ssr";

interface AttributedProductsData {
  designer: any;
  article: any;
  ancestors: any;
  attributes: Attribute[];
  featuredProducts: FeaturedProducts;
  products: any; // SSR Products Query Result
}

export interface SearchViewProps {
  params?: { slug: string };
  data: AttributedProductsData;
}
export const SearchView: NextPage = (props) => (
  <CategoryView {...props} isSearchPage />
);
